import { FC } from 'react'
import money from 'common/utils/number/money.ts'
import { planPrice } from 'common/utils/planPrice.ts'
import { PlanSlug } from 'common/types/responses.ts'

type WhatsappPriceType = {}

const WhatsAppPrice: FC<WhatsappPriceType> = ({}) => {
  return (
    <>
      <div className='text-danger fw-semibold' style={{ fontSize: '16px' }}>
        <s>£5.99/month</s>
      </div>
      <div className='d-flex align-items-end'>
        <span
          className='fw-bold'
          style={{ fontSize: '32px', lineHeight: '1.2' }}
        >
          {money(planPrice.monthly[PlanSlug.WHATSAPP])}
        </span>
        <span
          className='text-muted fw-semibold mb-1'
          style={{ fontSize: '16px' }}
        >
          /month
        </span>
      </div>
    </>
  )
}

export default WhatsAppPrice
